/**
 * The app's entry. Bootstrap's stylesheet first, then the brand layer that
 * redefines its custom properties — order matters, and this is the only place
 * either is imported.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import "bootstrap/dist/css/bootstrap.min.css";
import "./theme.css";
import { App } from "./App";
import { ThemeProvider } from "./components/theme";
import { SessionProvider } from "./useSession";

const container = document.getElementById("root");
if (!container) throw new Error('index.html is missing <div id="root">.');

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <SessionProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </SessionProvider>
    </ThemeProvider>
  </StrictMode>,
);
